export default __webpack_public_path__ + "static/media/payment_time.202017f9.png";